import MainTopBar from '@/components/common/bar/MainTopBar'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import CommonModal from '@/components/common/modal/CommonModal'
import NoticeListScreen from '@/components/notice/NoticeListScreen'
import NoticeDetailScreen from '@/components/notice/NoticeDetailScreen'
import { useNoticeDetail, useNoticeList } from '@/hooks/queries/notice'
import { useMarkAsReadNotice } from '@/hooks/queries/notice/mutation'
import { countUnreadNoticesCnt } from '@/utils/countUnreadNoticesCnt'

export interface Notice {
  id: string
  title: string
  message?: string
  type: 'info' | 'warning' | 'error' | 'success'
  isRead: boolean
  date: string
  createdAt: string
}

export default function NoticePage() {
  const [pageType, setPageType] = useState<'list' | 'detail'>('list')
  const [isReadAllModalOpen, setIsReadAllModalOpen] = useState(false)
  const [selectedNoticeId, setSelectedNoticeId] = useState<number>(0)
  const navigate = useNavigate()

  const { data: noticeList, isLoading: isNoticeListLoading, refetch: fetchNoticeList } = useNoticeList()
  const { data: noticeDetail, refetch: fetchNoticeDetail } = useNoticeDetail(selectedNoticeId)
  const { mutate: markAsReadAll } = useMarkAsReadNotice()

  const handleClickNotice = (noticeId: number) => {
    setSelectedNoticeId(noticeId)
    setPageType('detail')
  }

  const handleMarkAsReadAll = () => {
    markAsReadAll()
    setIsReadAllModalOpen(false)
  }

  useEffect(() => {
    if (pageType === 'detail' && selectedNoticeId) {
      fetchNoticeDetail()
    }
  }, [selectedNoticeId, pageType])

  useEffect(() => {
    if (pageType === 'list') {
      fetchNoticeList()
    }
  }, [pageType])

  return (
    <>
      <MainTopBar
        hasBackButton={true}
        handleClickBackButton={() => {
          if (pageType === 'list') {
            navigate('/')
          } else {
            setPageType('list')
          }
        }}
        leftSide={
          pageType === 'list' && (
            <>
              <div className='flex items-center '>
                <h1 className='text-header-title font-semibold text-text-header'>알림</h1>
              </div>
            </>
          )
        }
        rightSide={
          countUnreadNoticesCnt(noticeList?.notices ?? []) > 0 &&
          pageType === 'list' && (
            <button
              onClick={() => setIsReadAllModalOpen(true)}
              className='text-sm font-medium text-amber-900 bg-white/20 hover:bg-white/30 px-3 py-2 rounded-full transition-colors text-nowrap'
            >
              모두 읽음
            </button>
          )
        }
      />
      <div className='min-h-screen'>
        {/* 메인 콘텐츠 */}
        {pageType === 'list' ? (
          <NoticeListScreen
            loading={isNoticeListLoading}
            notices={noticeList?.notices ?? []}
            unreadCount={countUnreadNoticesCnt(noticeList?.notices ?? [])}
            handleClickNotice={handleClickNotice}
          />
        ) : (
          <NoticeDetailScreen notice={noticeDetail ?? null} />
        )}
      </div>

      {isReadAllModalOpen && (
        <CommonModal
          title={`읽지 않은 메시지가 모두 읽음 처리 됩니다. \n 계속 하시겠습니까? `}
          topButtonText='네'
          bottomButtonText='취소'
          topButtonOnClick={handleMarkAsReadAll}
          bottomButtonOnClick={() => setIsReadAllModalOpen(false)}
          isTopButtonDisabled={false}
          hasCloseButton={false}
          onClose={() => setIsReadAllModalOpen(false)}
        />
      )}
    </>
  )
}
